import React, { FC, memo } from 'react';
// mui components
import { Avatar, Grid, Typography } from '@mui/material';
// components
import DefaultAvatar from 'components/default-avatar';
// api
import { IProjectProfiles } from 'redux-store/api/projects';
// helpers
import { getImageBySize } from 'utils/helpers';
// styles
import { styles } from './styles';

interface IUserTagProps {
  profile: IProjectProfiles;
  isSelected: boolean;
  onCustomUserToggle: () => void;
}

const UserTag: FC<IUserTagProps> = ({ profile, isSelected, onCustomUserToggle }) => {
  return (
    <Grid
      sx={{ ...styles.tagContainer, border: isSelected ? '1px solid #4D6EF5' : '1px solid #fff' }}
      onClick={onCustomUserToggle}
    >
      <Grid sx={styles.avatarContainer}>
        {profile?.avatar ? (
          <Avatar
            alt="avatar"
            sx={{ width: '28px', height: '28px', borderRadius: '4px' }}
            src={getImageBySize(profile.avatar, 40, 40, false)}
            variant="square"
          />
        ) : (
          <DefaultAvatar
            initials={`${profile?.firstName[0]}${profile.lastName[0]}`}
            alt="avatar"
            variant="square"
            sx={{ width: '28px', height: '28px', borderRadius: '4px' }}
          />
        )}
      </Grid>
      <Typography sx={styles.userName}>{`${profile.firstName} ${profile.lastName}`}</Typography>
    </Grid>
  );
};

export default memo(UserTag);
